import { useState, useEffect } from "react";
import { useGetAllCommunicationMethodQuery } from "src/services/CommunicationMethodServices";
const useCommunicationMethod = () => {
    const [CommunicationMethod, setCommunicationMethod] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllCommunicationMethodQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setCommunicationMethod(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { CommunicationMethod, isDataLoading };
};

export default useCommunicationMethod;
